import * as React from 'react';

export function ChevronRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28 3.22a.75.75 0 00-1.06 1.06l5.564 5.565L6.22 15.41a.75.75 0 001.06 1.06l6.09-6.09a.748.748 0 00.22-.536.748.748 0 00-.22-.534L7.28 3.22z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChevronRight;
